import { TechnicalCategoryType } from '@models';
import { useStore } from '@stores';
import { observer } from 'mobx-react';
import React, { useCallback } from 'react';
import Presentation from './TechnicalCategoryMenu.presentation';

interface IProps {
  vin: string;
  category: string;
  setCategory: (category: string) => void;
}

export const TechnicalCategoryMenu: React.FC<IProps> = observer(
  ({ vin, category, setCategory }) => {
    const { technicalCategoryStore } = useStore();
    const { categories, subCategoriesLoading, selectedCategoryId } = technicalCategoryStore;

    const onCollapseChange = useCallback(
      async (key: string) => {
        setCategory(key as string);
        technicalCategoryStore.clearSubCategories();
        technicalCategoryStore.clearSelectedCategory();

        if (!key) return;

        const category = key as TechnicalCategoryType;
        await technicalCategoryStore.getCategoriesByVinAndCategory({ vin, category });
      },
      [vin, technicalCategoryStore, setCategory]
    );

    const onCategorySelect = useCallback(
      async (id: string) => {
        await technicalCategoryStore.getSubCategoriesByCategoryId({ id });
      },
      [technicalCategoryStore]
    );

    return (
      <Presentation
        category={category}
        categories={categories}
        loading={subCategoriesLoading}
        selectedCategoryId={selectedCategoryId}
        onCategorySelect={onCategorySelect}
        onCollapseChange={onCollapseChange}
      />
    );
  }
);
